// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NavLink_wrapper__2pFmG","active":"NavLink_active__3sTUF","icon":"NavLink_icon__1jWGE","label":"NavLink_label__3eGsG"};